module.exports = __webpack_public_path__ + "BuildablePlan-3WEo49g.svg";